module.exports = __webpack_public_path__ + "static/sen-fcf7e6de4420fd6fe3c2302c910f3111.jpg";